import { Component, OnDestroy, OnInit } from '@angular/core';
import { AtlasService } from '../atlas.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';

@Component({
  selector: "app-atlas-ready-to",
  templateUrl: "./atlas-ready-to.component.html",
  imports: [
    CommonModule,
    TalkToSalesButtonComponent
  ]
})
export class AtlasReadyToComponent {
  subscriptions = new Array<any>();
  readyToData: any;
  constructor(private atlasPageService: AtlasService) {
    this.subscriptions = [];
  }
  isModalOpen = false;
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  ngOnInit(): void {
    this.atlasPageService.readyTo$.subscribe(data => {
      if (data) {
        this.readyToData = data;
      }
    });
  }
}